import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 8C20 8.24 19.92 8.47 19.75 8.66L12.75 16.66C12.56 16.88 12.29 17 12 17C11.71 17 11.44 16.88 11.25 16.66L4.24997 8.66C3.98997 8.36 3.92997 7.94 4.08997 7.59C4.24997 7.23 4.60997 7 4.99997 7H19C19.39 7 19.75 7.23 19.91 7.59C19.97 7.72 20 7.86 20 8Z" fill={ fill || 'currentColor' }/>
    </svg>

);
